import { createRoot } from "react-dom/client";

import init, { Simulation } from "../pkg";

import { Game } from "./components/Game";

async function start() {
    await init();

    const width = 128;
    const height = 128;
    const simulation = new Simulation(width, height);

    createRoot(document.querySelector("#game-root")!).render(
        <Game simulation={simulation} />,
    );
}

void start();
